// TODO: Add more submission types once they're added to the API
// When adding a new submission type, SubmissionPermissionUtils and InternalUserSubmissionPermissionMap must be updated

export enum MemberSubmissionTypeEnum {
  NameChange = 1,
  AddressChange = 2,
  UpdateContactInfo = 3,
  PersonalInfoChange = 4,
  ChangeInvestmentInstructions = 5,
  RelationshipStatusChange = 6,
  DefinedContributionBeneficiaryChange = 7,
  BankingInformation = 8,
  UpdateLegalFiduciary = 9,
  VariableBenefitConfiguration = 10,
  UpdateVariableBenefitConfiguration = 11,
  VariableBenefitPaymentChange = 12,
  VariableBenefitBeneficiaryChange = 13,
  MonthlyPensionSetup = 14,
  UpdateMonthlyPensionBeneficiaries = 15,
  AddPaylineAccount = 16,
  TransferIn = 17
}
